jQuery(document).ready(function() {

// BEGIN of script for .slider-testimonials
	$('.slider-text-carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		adaptiveHeight: false,
		autoplay: true,
		cssEase: 'linear',
		infinite: true,
		autoplaySpeed: 0,
		fade: false,
		pauseOnHover: false,
		speed: 3000,
		variableWidth: true,
		centerMode: false,
	});
// END of script for .slider-testimonials

// BEGIN of script for .slider-testimonials
	$('.slider-testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 5500,
		fade: false,
		pauseOnHover: false,
		speed: 600,
		variableWidth: true,
		centerMode: false,
	});
// END of script for .slider-testimonials

// BEGIN of script for slider-3-per-row
	$('.slider-3-per-row').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: false,
		pauseOnHover: false,
		speed: 600,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});
// END of script for slider-3-per-row

// BEGIN of script for accordion
	$('.accordion-item-nav').click(function(){
		var _accItemParent = $(this).parents('.accordion-item');
		if (_accItemParent.hasClass('active')) {
			$('.accordion-item').removeClass('active');
			$('.accordion-item .accordion-item-content').slideUp(400,function(){
			});
		} else {
			// $('.accordion-item').removeClass('active');
			// $('.accordion-item .accordion-item-content').slideUp(400);
			_accItemParent.addClass('active');
			_accItemParent.find('.accordion-item-content').slideDown(400,function(){
			});
		}
	})
	$('.accordion-item:first .accordion-item-nav').click();
// END of script for accordion

// BEGIN of script for tabs
	$('.tabs-nav-item').click(function() {
		var _id = $(this).attr('href');
		var _targetElement = $(this).parents('.tabs-wr').find(_id);
		$('.tabs-nav-item').removeClass('active');
		$('.tabs-nav-item-wrapper').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.tabs-nav-item-wrapper').addClass('active');
		$('.tabs-item').removeClass('active');
		_targetElement.addClass('active');
		return false;
	});

	$('.btn-close-tab').click(function(){
		$(this).parents('.tabs-item').removeClass('active');
	})
	// $('.tabs-nav-item:last-child').click();
// END of script for tabs

// BEGIN of script to clone element into other position for mobile views
	$('.mobile-move-element').each(function(){
		var _cloneElement = $(this).clone();
		_cloneElement.appendTo($(this).parents('.box-wr').find('.mobile-move-element-position'));
	});
// END of script to clone element into other position for mobile views



















});

// BEGIN of script for page load
	window.onload = function() {

	// BEGIN of script for page preloader
		$('.spinner-wr').fadeOut(900,function(){
			$(this).remove();
		});
		$('body').addClass('loaded');
	// END of script for page preloader

	// BEGIN of script for init wow.js for animate.css
		if(Modernizr.cssanimations) {
			wow = new WOW({
				mobile: false,
			});
			wow.init();
		}
	// END of script for init wow.js for animate.css

	};
// END of script for page loader